module.exports = __webpack_public_path__ + "static/img/DZ.7155e5e0.svg";